// src/constants/sidebarItems.js
import {
    Dashboard,
    Category,
    AccountTree,
    WorkspacePremium,
    LocalOffer,
    Description,
    ViewQuilt,
    Article,
    Tune,
    Inventory,
    CollectionsBookmark,
    Person,
    Style,
    Newspaper,
    ContentCut,
    ShoppingCart,
    People,
    AssignmentReturn,
    Warehouse,
    Inventory2,
    LocalShipping,
    Receipt,
    Settings as SettingsIcon,
    Tune as TuneIcon,
    AdminPanelSettings,
    Payments,
    NotificationsActive,
    IntegrationInstructions,
    ContactPhone,
    Webhook,
} from "@mui/icons-material";


export const sidebarItems = [
    {
        key: 'dashboard',
        label: { en: 'Dashboard', ar: 'لوحة التحكم' },
        path: '/dashboard',
        icon: Dashboard,
    },

    /* ------------------------------------------------------------------ */
    /* Catalog                                                             */
    /* ------------------------------------------------------------------ */
    {
        key: 'departments',
        label: { en: 'Departments', ar: 'الأقسام' },
        path: '/departments',
        icon: AccountTree,
    },
    {
        key: 'categories',
        label: { en: 'Categories', ar: 'الفئات' },
        path: '/categories',
        icon: Category,
    },
    {
        key: 'brands',
        label: { en: 'Brands', ar: 'العلامات التجارية' },
        path: '/brands',
        icon: WorkspacePremium,
    },
    {
        key: 'tags',
        label: { en: 'Tags', ar: 'الوسوم' },
        path: '/tags',
        icon: LocalOffer,
    },
    {
        key: 'option-groups',
        label: { en: 'Option Groups', ar: 'مجموعات الخيارات' },
        path: '/option-groups',
        icon: Tune,
    },
    {
        key: 'products',
        label: { en: 'Products', ar: 'المنتجات' },
        path: '/products',
        icon: Inventory,
    },
    {
        key: 'collections',
        label: { en: 'Collections', ar: 'المجموعات' },
        path: '/collections',
        icon: CollectionsBookmark,
    },
    {
        key: 'coupons',
        label: { en: 'Coupons', ar: 'الكوبونات' },
        path: '/coupons',
        icon: ContentCut,
    },

    /* ------------------------------------------------------------------ */
    /* Sales                                                               */
    /* ------------------------------------------------------------------ */
    {
        key: 'orders',
        label: { en: 'Orders', ar: 'الطلبات' },
        path: '/orders',
        icon: ShoppingCart,
    },
    {
        key: 'customers',
        label: { en: 'Customers', ar: 'العملاء' },
        path: '/customers',
        icon: People,
    },
    {
        key: 'returns',
        label: { en: 'Returns', ar: 'المرتجعات' },
        path: '/returns',
        icon: AssignmentReturn,
    },

    /* ------------------------------------------------------------------ */
    /* Stock                                                               */
    /* ------------------------------------------------------------------ */
    {
        key: 'stock',
        label: { en: 'Stock', ar: 'المخزون' },
        icon: Warehouse,
        children: [
            {
                key: 'warehouses',
                label: { en: 'Warehouses', ar: 'المستودعات' },
                path: '/warehouses',
                icon: Warehouse,
            },
            {
                key: 'inventory',
                label: { en: 'Inventory', ar: 'المخزون' },
                path: '/inventory',
                icon: Inventory2,
            },
        ],
    },

    /* ------------------------------------------------------------------ */
    /* Delivery                                                            */
    /* ------------------------------------------------------------------ */
    {
        key: 'delivery',
        label: { en: 'Delivery', ar: 'الشحن والضرائب' },
        icon: LocalShipping,
        children: [
            {
                key: 'shipping',
                label: { en: 'Shipping', ar: 'الشحن' },
                path: '/shipping',
                icon: LocalShipping,
            },
            {
                key: 'tax',
                label: { en: 'Tax', ar: 'الضرائب' },
                path: '/tax',
                icon: Receipt,
            },
        ],
    },

    /* ------------------------------------------------------------------ */
    /* Content                                                             */
    /* ------------------------------------------------------------------ */
    {
        key: 'pages',
        label: { en: 'Pages', ar: 'الصفحات' },
        path: '/pages',
        icon: Description,
    },
    {
        key: 'home-sections',
        label: { en: 'Home Sections', ar: 'أقسام الصفحة الرئيسية' },
        path: '/home-sections',
        icon: ViewQuilt,
    },
    {
        key: 'blog',
        label: { en: 'Blog', ar: 'المدونة' },
        icon: Article,
        children: [
            {
                key: 'post-tags',
                label: { en: 'Tags', ar: 'الوسوم' },
                path: '/blog/tags',
                icon: Style
            },
            {
                key: 'post-categories',
                label: { en: 'Categories', ar: 'التصنيفات' },
                path: '/blog/categories',
                icon: Category
            },
            {
                key: 'posts',
                label: { en: 'All Posts', ar: 'كل المقالات' },
                path: '/blog/posts',
                icon: Newspaper
            },
        ],
    },

    /* ------------------------------------------------------------------ */
    /* System / Settings                                                   */
    /* ------------------------------------------------------------------ */
    {
        key: 'settings',
        label: { en: 'Settings', ar: 'الإعدادات' },
        icon: SettingsIcon,
        children: [
            {
                key: 'settings-general',
                label: { en: 'General', ar: 'عامة' },
                path: '/settings/general',
                icon: TuneIcon,
            },
            {
                key: 'settings-contact',
                label: { en: 'Contact', ar: 'بيانات التواصل' },
                path: '/settings/contact',
                icon: ContactPhone,
            },
            {
                key: 'settings-roles',
                label: { en: 'Roles', ar: 'الصلاحيات' },
                path: '/settings/roles',
                icon: AdminPanelSettings,
            },
            {
                key: 'settings-payment',
                label: { en: 'Payment', ar: 'الدفع' },
                path: '/settings/payment',
                icon: Payments,
            },
            {
                key: 'settings-notifications',
                label: { en: 'Notifications', ar: 'الإشعارات' },
                path: '/settings/notifications',
                icon: NotificationsActive,
            },
            {
                key: 'settings-integrations',
                label: { en: 'Integrations', ar: 'التكاملات' },
                path: '/settings/integrations',
                icon: IntegrationInstructions,
            },
            {
                key: 'settings-webhooks',
                label: { en: 'Webhooks', ar: 'Webhooks' },
                path: '/settings/integrations/webhooks',
                icon: Webhook,
            },
        ],
    },

    {
        key: 'profile',
        label: { en: 'Profile', ar: 'الملف الشخصي' },
        path: '/profile',
        icon: Person,
    },
];
